import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import Buttons from '../../components/buttons/buttons'
import PageOverlay from '../../pageoverLay/pageoverLay'
import InputTextarea from '../../utils/controls/input-textarea'
import './home.css'
import Searchresults from '../../components/search-results/search-results'
// import {  UserContext } from '../../shared/contexts/role-context'
import { AuthContext } from '../../shared/contexts/AuthContextProvider'
import { formatTimestamp, getFileNameWithoutExtension } from '../../Global'
import {  BASE_URL } from '../../configuration'
import { useLocation, useNavigate } from 'react-router-dom'


export default function Home(props:any) {
    const {loginUserRoles,loadingRoles,accessToken, chathistory, setChathistory} = useContext(AuthContext)
    const [loading, setLoading] = useState(false)
    const [query, setQuery] = useState('')
    const [response, setResponse] = useState('')
    const [history, setHistory] = useState<{ query: string; response: string }[]>([])
    // const [chathistory,setChathistory]= useState<any>([])
    const [showSearchResults, setShowSearchResults] = useState(false)
    const [disable, setDisable] = useState(true)
    const [files, setFiles] = useState<any>([])
    const [data, setData] = useState<{ query: string; response: string }[]>([])
    const [pdfSource, setPdfSource] = useState('')
    const [activePdfSource, setActivePdfSource] = useState('')
    const [pdfOpen,setPDFOpen] = useState(false)
    const [isSearchResultsFullScreenExpand, setIsSearchResultsFullScreenExpand] = useState(false)
    const [isPdfFullScreenExpand, setIsPdfFullScreenExpand] = useState(false)
    const location = useLocation()
    const [cleanedFileName, setCleanedFileName] = useState<string>()
    const [searchKey, setSearchKey] = useState(0)
    const navigate = useNavigate()
    const [displayedHistory, setDisplayedHistory] = useState<any[]>([])

    useEffect(() => {
        return () => {
            if (pdfSource.startsWith('blob:')) {
                URL.revokeObjectURL(pdfSource)
            }
        }
    }, [pdfSource])

    useEffect(() => {
        if (location.hash.startsWith('#history/')) {
            const id = location.hash.replace('#history/', '')
            const singleItem = chathistory.find((item: any) => item.id === id)
            setDisplayedHistory(singleItem ? [singleItem] : [])
        } else {
            setDisplayedHistory(chathistory)
        }
    }, [location.hash, chathistory])

    const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setQuery(e.target.value)
        if(e.target.value !=''){
            setDisable(false)
        }
        else{
            setDisable(true)  
        }
    }
    // Handle send button click
    const handleSend = async () => {
        if (query.trim() === '') return
        if (location.hash.startsWith('#history/')) {
            navigate('/')
        }
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
    
        setLoading(true)
        try {
            const response = await axios.post(`${BASE_URL}/chat`, { query }, { headers })
            const data = response.data
            setData(data)
            const historyResponse = await axios.get(`${BASE_URL}/chat_history`, { headers })
            const historyData = historyResponse.data

            const filteredChatHistory = historyData?.history
                ?.filter((item: any) => item?.email?.toLowerCase() === loginUserRoles?.unique_name?.toLowerCase())
                ?.map((item: any, index: number) => ({
                    ...item,
                    id: `chat-item-${index}`,
                    formattedTimestamp: formatTimestamp(item.timestamp),
                }))
            
            setChathistory(filteredChatHistory)

            if (response.status === 200) {
                setShowSearchResults(true)
                setResponse(data.answer)
                setHistory((prevHistory) => {
                    const newHistory = [...prevHistory, { query, response: data.answer }]
                    return newHistory.length > 10 ? newHistory.slice(1) : newHistory
                })
                setSearchKey(prevKey => prevKey + 1)
            } else {
                setShowSearchResults(false)
                console.error('Error:', data.error)
                setResponse('An error occurred. Please try again.')
            }
        } catch (error) {
            console.error('Request failed:', error)
            setResponse('An error occurred. Please try again.')
        } finally {
            setLoading(false)
        }
    }
useEffect(() => {
        if (searchKey > 0) {
            setTimeout(() => {
                document.getElementById('wrapper')?.scrollTo({ top: 0, behavior: 'smooth' })
            }, 0)
        }
    }, [searchKey])
     const fetchTopFaqs = async () => {
        if (!accessToken || !loginUserRoles?.unique_name) return

        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        }
        setLoading(true)
        try {
            const chatHistoryResponse = await axios.get(`${BASE_URL}/chat_history`, { headers })
            const chatHistoryData = chatHistoryResponse?.data?.history

            const filteredChatHistory = chatHistoryData
                ?.filter((item: any) => item?.email?.toLowerCase() === loginUserRoles?.unique_name?.toLowerCase())
                ?.map((item: any, index: number) => ({
                    ...item,
                    id: `chat-item-${index}`,
                    formattedTimestamp: formatTimestamp(item.timestamp),
                })) || []
                
                setChathistory(filteredChatHistory)
        } catch (error:any) {
            console.error('Error fetching data:', error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (loginUserRoles?.unique_name) {
            fetchTopFaqs()
        }
    }, [loginUserRoles])


    const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            await handleSend()
        }
    }
    const getPDFSource = async (source:string)=>{
        const sourceFileName = source.trim()
        setIsPdfFullScreenExpand(false)
        setIsSearchResultsFullScreenExpand(false)
        setCleanedFileName(getFileNameWithoutExtension(sourceFileName))
        setActivePdfSource(sourceFileName)
        setLoading(true)
        try {
            const fileResponse = await axios.get(`${BASE_URL}/view-file`, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                },
                params: {
                    file_name: sourceFileName
                },
                responseType: 'blob'
            })
            const fileUrl = URL.createObjectURL(fileResponse.data)
            setPdfSource(fileUrl)
            setPDFOpen(true)
        } catch (error) {
            console.error('Error fetching file:', error)
        } finally {
            setLoading(false)
        }
       }
    const fileClose =()=>{
        setPDFOpen(false)
        if (pdfSource.startsWith('blob:')) {
            URL.revokeObjectURL(pdfSource)
        }
        setPdfSource('')
        setActivePdfSource('')
       }
    const showSearchResultsExpandFull = () => {
        props?.setIsOpen(false)
        setIsPdfFullScreenExpand(false)
        setIsSearchResultsFullScreenExpand(prev => !prev)
    }

    const showPdfExpandFull = () => {
        props?.setIsOpen(false)
        setIsSearchResultsFullScreenExpand(false)
        setIsPdfFullScreenExpand(prev => !prev)
    }

    return (
        <>{loading  && <PageOverlay />} 
            <div className='container'>
                <div className="d-flex flex-column maxfitcontent gap-1 mt-2" tabIndex={0} aria-live='polite'>
                    <h3 className='segoeui-bold font-26 title-color16 m-0'>Hi {loginUserRoles?.name},</h3>
                    <h3 className='segoeui-bold font-26 title-color16 m-0'>Is there anything I can support you with?</h3>
                </div>
                <div className='row p-relative'>
                    <div className={pdfOpen? `col-12 col-lg-6 col-xxl-4 ${isSearchResultsFullScreenExpand ? 'fullscreen' : ''}`:`col-12 search-section ${isSearchResultsFullScreenExpand ? 'fullscreen' : ''}`}>
                            <div className="search-content p-relative">
                                <div className={`bordered11 card shadow card-lg w-100 border-radius2 mb-3 overflow-hidden ${isSearchResultsFullScreenExpand ? 'd-none':''}`}>
                                    <div className="card-header pb-0 d-flex align-items-end">
                                        <div className='d-flex align-items-center w-100 gap-1'>
                                            <InputTextarea label='Query Input' labelclassName="font-0" formClassName="w-100 d-flex" className="h-60 no-border w-100 query-input-textarea"
                                                inputProps={{
                                                    id: 'queryInput',
                                                    className: 'font-0',
                                                    placeholder: '\'Hello! I\'m your Financial Assistant. How can I assist you today?\'',
                                                    value: query,
                                                }}
                                                onChange= {handleInputChange}
                                                onKeyDown =  {handleKeyDown}
                                            />
                                            <Buttons  label="Send" type="button" className={`${disable ? 'btn border-radius4 font-0 bgcolor-26 pointer-events-none':'btn border-radius4 font-0 bgcolor-primary'}`} icon="icon-arrow-up whitetext font-14" onClick={handleSend} />
                                        </div>
                                    </div>
                                    <div className="d-flex card-footer bgcolor-22 border-top11 mt-2 py-1">
                                        <div className='d-flex align-items-center w-100'>
                                        <Buttons
                                            label="New Chat"
                                            className="btn-sm p-0 font-14 segoeui-semibold color-primary"
                                            icon='icon-add me-1 font-12'
                                            onClick={()=>{setQuery(''),
                                            setDisable(true),
                                            setFiles([])}}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <Searchresults key={searchKey} history={history}  isSearchResultsFullScreenExpand={isSearchResultsFullScreenExpand} showSearchResultsExpandFull={showSearchResultsExpandFull} chathistory={displayedHistory} loginUserRoles={loginUserRoles} getPDFSource ={getPDFSource} activePdfSource={activePdfSource}/>
                                </div>
                            </div>
                        </div>
                    {pdfSource && (
                    <div className={`col-12 col-lg-6 col-xxl-8  ${isPdfFullScreenExpand ? 'fullscreen': ''}`}>
                        <div className="d-flex flex-column shadow whitebg border-radius2 px-3 h-100">
                            <div className="d-flex align-items-center py-2">
                                <div>
                                    <span className='icon-pdf-outline p-1 bgcolor-27 border-radius4 whitetext me-2'></span>
                                    {cleanedFileName}.pdf
                                </div>
                                <div className="d-flex align-items-center gap-1 ms-auto">
                                    <Buttons
                                        label={isPdfFullScreenExpand ? 'Fullscreen collapsed' : 'Expand Fullscreen'}
                                        className="font-0 color-primary ms-auto"
                                        icon={isPdfFullScreenExpand ? 'icon-shrink2 font-14 me-0' : 'icon-expand font-14 me-0'}
                                        onClick={showPdfExpandFull}
                                    />
                                    <div className="dividerdashed vertical mx-1"></div>
                                    <Buttons
                                        label=""
                                        aria-label="Close"
                                        icon="icon-close me-1 font-9"
                                        className='btn-xs text-nowrap border-radius ms-auto my-1 p-0'
                                        onClick={()=>fileClose()}
                                    />
                                </div>
                            </div>
                            <div className='h-100 mb-3'><iframe src={pdfSource} width="100%" height="100%" style={{ border: 'none' }} /></div>
                        </div>
                    </div>
                )}
                </div>
            </div>
        </>
    )
}